import Minntech from "../../assets/images/Minntech.svg";
import EnglandFlag from "../../assets/images/england.svg";
import TurkeyFlag from "../../assets/images/turkey.svg";
import "./header.css";
import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import { useTranslation } from "react-i18next";

const options = [
  {
    value: "EN",
    label: "EN",
    icon: EnglandFlag,
  },
  {
    value: "TR",
    label: "TR",
    icon: TurkeyFlag,
  },
];

const Option = (props) => (
  <components.Option {...props} className="option">
    <img src={props.data.icon} alt="logo" className="option-flag" />
    {props.data.label}
  </components.Option>
);

const Header = () => {
  const storedLang = localStorage.getItem("lang");
  let lng = storedLang ?? navigator.language;
  const initialLang = lng === "en-US" ? options[0] : options[1];
  const [selectedOption, setSelectedOption] = useState(initialLang);
  const [openMenu, setOpenMenu] = useState("");
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [lng, i18n]);

  const handleChangeLang = (e) => {
    if (e.value === "EN") {
      localStorage.setItem("lang", "en-US");
    } else {
      localStorage.setItem("lang", "tr-TR");
    }
    setSelectedOption(e);
  };

  let menuClass = "menu-button";
  let closeClass = "close-button";

  const handleMenu = () => {
    if (openMenu === "opened-menu") {
      setOpenMenu("");
    } else {
      setOpenMenu("opened-menu");
    }
  };

  const closeMenu = () => {
    if (openMenu === "opened-menu") {
      setOpenMenu("");
    }
  };

  const SingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      <img src={selectedOption.icon} alt="s-logo" className="selected-flag" />
      {children}
    </components.SingleValue>
  );

  return (
    <header className={`${"header"} ${openMenu}`}>
      <img src={Minntech} className="logo" alt="logo" />
      <nav>
        <ul className="main-nav-bar">
          <li>
            <a
              href="#autonomous-robot"
              className="main-nav-link"
              onClick={closeMenu}
            >
              {t("header.autonomous_robot")}
            </a>
          </li>
          <li>
            <a href="#prototype" className="main-nav-link" onClick={closeMenu}>
              {t("header.prototype")}
            </a>
          </li>
          <li>
            <a href="#about_us" className="main-nav-link" onClick={closeMenu}>
              {t("header.about_us")}
            </a>
          </li>
          <li>
            <a href="#contact" className="main-nav-link" onClick={closeMenu}>
              {t("header.contact_us")}
            </a>
          </li>
          <Select
            className="select"
            isSearchable={false}
            value={selectedOption}
            options={options}
            onChange={handleChangeLang}
            styles={{
              singleValue: (base) => ({
                ...base,
                display: "flex",
                alignItems: "center",
              }),
            }}
            theme={(theme) => ({
              ...theme,
              borderRadius: 5,

              colors: {
                ...theme.colors,
                primary25: "#f4fce3",
                primary: "#51cf66",
              },
            })}
            components={{
              Option,
              SingleValue,
            }}
          />
        </ul>
      </nav>
      <button className="nav-menu" onClick={handleMenu}>
        <ion-icon class={menuClass} name="menu-outline"></ion-icon>
        <ion-icon class={closeClass} name="close-outline"></ion-icon>
      </button>
    </header>
  );
};

export default Header;
